<template>
  <section class="obra-chapter-list" :aria-labelledby="showHeading ? headingId : null" :aria-label="showHeading ? null : heading">
    <div v-if="showHeading" class="obra-chapter-list__heading">
      <h2 :id="headingId">{{ heading }}</h2>
      <span>{{ chapters.length }} {{ countLabel }}</span>
    </div>
    <div v-if="displayedChapters.length" class="obra-chapter-list__items">
      <ObraChapterCard v-for="chapter in displayedChapters" :key="chapter.id" :chapter="chapter" :project-thumb="projectThumb" :is-admin="isAdmin" :show-like="showLike" :show-social-meta="showSocialMeta" @open="$emit('open-chapter', $event)" @like="$emit('like-chapter', $event)" @delete="$emit('delete-chapter', $event)" />
    </div>
    <div v-else class="obra-empty-state">{{ emptyText }}</div>
    <div v-if="showExpandControl && canExpand" class="obra-chapter-list__expand">
      <v-btn class="obra-chapter-list__expand-button" text small @click="$emit('toggle-expanded')">
        {{ expanded ? 'Demonstrar menos' : 'Demonstrar mais' }}
        <v-icon right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
  </section>
</template>

<script>
import ObraChapterCard from './ObraChapterCard.vue';

export default {
  name: 'ObraChapterList',
  components: { ObraChapterCard },
  props: {
    chapters: { type: Array, default: () => [] },
    projectThumb: { type: String, default: '' },
    expanded: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    limit: { type: Number, default: 5 },
    heading: { type: String, default: 'Capitulos' },
    emptyText: { type: String, default: 'Nenhum capitulo publicado ainda.' },
    countLabel: { type: String, default: 'publicados' },
    showExpandControl: { type: Boolean, default: true },
    showLike: { type: Boolean, default: true },
    showSocialMeta: { type: Boolean, default: true },
    showHeading: { type: Boolean, default: true },
  },
  computed: {
    headingId() {
      return 'obra-chapters-title';
    },
    canExpand() {
      return this.chapters.length > this.limit;
    },
    displayedChapters() {
      return this.expanded ? this.chapters : this.chapters.slice(0, this.limit);
    },
  },
};
</script>
